module.exports = __webpack_public_path__ + "img/wh-li-icon6.7590eb2f.png";